import styled from 'styled-components';

const SpacerDiv = styled.div``;

const Spacer = ({ vertical = 8, horizontal = 0 }) => {
    return <SpacerDiv style={{height: vertical, width: horizontal}}/>;
}

export default Spacer
